import { render, staticRenderFns } from "./insurance-results.vue?vue&type=template&id=6b488bfb"
import script from "./insurance-results.vue?vue&type=script&lang=js"
export * from "./insurance-results.vue?vue&type=script&lang=js"
import style0 from "./insurance-results.vue?vue&type=style&index=0&id=6b488bfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports